import { useState } from "react";
import { FiPlus } from "react-icons/fi";
import { DataTable } from "@iq/models";
import CreatePayment from "../../../modals/CreatePayment";
import "./Payment.css";

const PAYMENT_HISTORY_TABLE_CONFIG = {
	columns: [
		{ key: "stage", label: "Stage", accessor: "stage", filterable: true },
		{ key: "name", label: "Invoice", accessor: "name", filterable: true },
		{ key: "account", label: "Account", accessor: "account", filterable: true },
		{ key: "email", label: "Email", accessor: "email", filterable: true },
		{ key: "plan", label: "Plan", accessor: "plan", filterable: true },
		{ key: "paid", label: "Paid", accessor: "paid", filterable: true },
		{ key: "nextPaymentDate", label: "Next Payment", accessor: "nextPaymentDate", filterable: true },
		{ key: "amount", label: "Amount", accessor: "amount", filterable: true },
	],
};

// TODO: replace with real payment history once the backend endpoint is available
const MOCK_PAYMENTS = [
	{
		id: 1,
		stage: "Paid",
		name: "Invoice #1042",
		account: "Acme Inc.",
		email: "billing@acme.com",
		phone: "(555) 123-4567",
		plan: "Monthly Subscription",
		paid: "Yes",
		nextPaymentDate: "2026-06-15",
		amount: "$499.00",
	},
	{
		id: 2,
		stage: "Paid",
		name: "Invoice #1038",
		account: "Acme Inc.",
		email: "billing@acme.com",
		phone: "(555) 123-4567",
		plan: "Monthly Subscription",
		paid: "Yes",
		nextPaymentDate: "2026-05-15",
		amount: "$499.00",
	},
	{
		id: 3,
		stage: "Pending",
		name: "Invoice #1051",
		account: "Acme Inc.",
		email: "billing@acme.com",
		phone: "(555) 123-4567",
		plan: "Monthly Subscription",
		paid: "No",
		nextPaymentDate: "2026-07-15",
		amount: "$499.00",
	},
];

function Payment({ clientId, client }) {
	const [payments] = useState(MOCK_PAYMENTS);
	const [isCreatePaymentOpen, setIsCreatePaymentOpen] = useState(false);

	function handleCreatePayment() {
		setIsCreatePaymentOpen(true);
	}

	function handleCloseCreatePayment() {
		setIsCreatePaymentOpen(false);
	}

	return (
		<section className="payment-tab-container" aria-label="Client payments">
			<header className="payment-tab-header">
				<div>
					<h3>Payments</h3>
					<p className="payment-tab-subtitle">
						{payments.length > 0 ? `${payments.length} Past Payment${payments.length > 1 ? "s" : ""}` : "No payments yet"}
					</p>
				</div>
				<button
					type="button"
					className="payment-tab-btn"
					onClick={handleCreatePayment}
				>
					<FiPlus /> Create Payment
				</button>
			</header>

			<div className="payment-tab-table-wrap">
				<DataTable rowData={payments} loading={false} tableConfig={PAYMENT_HISTORY_TABLE_CONFIG} />
			</div>

			<CreatePayment
				isOpen={isCreatePaymentOpen}
				onClose={handleCloseCreatePayment}
				clientId={clientId}
				client={client}
			/>
		</section>
	);
}

export default Payment;
